var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9047 0.292892C14.2952 -0.0976318 14.9283 -0.0976298 15.3189 0.292892L17.4403 2.41421L20.2687 5.24263L22.3899 7.36395C22.7805 7.75449 22.7805 8.38765 22.3899 8.77817C21.9995 9.16869 21.3663 9.16869 20.9757 8.77817L19.6697 7.47215L12.3967 17.1696L14.6118 19.3848C15.0023 19.7754 15.0023 20.4086 14.6118 20.799C14.2213 21.1896 13.5881 21.1896 13.1976 20.799L10.3692 17.9706L8.24785 15.8493L1.70711 22.39C1.31659 22.7806 0.68341 22.7806 0.29289 22.39C-0.09763 21.9996 -0.09763 21.3664 0.29289 20.9758L6.83363 14.435L4.71231 12.3137L1.88389 9.48527C1.49337 9.09475 1.49335 8.46159 1.88389 8.07107C2.27441 7.68055 2.90757 7.68055 3.29809 8.07107L5.51325 10.2862L15.2107 3.01313L13.9047 1.70711C13.5142 1.31659 13.5142 0.683412 13.9047 0.292892Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.8aed51838aec2325bf3480f1d0ce69b5.svg";
export { ForwardRef as ReactComponent };